import { render } from "./PatchnoteMyCarto.vue?vue&type=template&id=13be5d70&scoped=true&ts=true"
import script from "./PatchnoteMyCarto.vue?vue&type=script&lang=ts"
export * from "./PatchnoteMyCarto.vue?vue&type=script&lang=ts"

import "./PatchnoteMyCarto.vue?vue&type=style&index=0&id=13be5d70&scoped=true&lang=css"
/* custom blocks */
import block0 from "./PatchnoteMyCarto.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13be5d70"]])

export default __exports__